import type { CallAnalysisCrmTask } from '@marnic/shared';
import { MiniSection } from '../primitives/MiniSection';
import { RiskBadge } from '../primitives/RiskBadge';

interface Props {
  crmTask: CallAnalysisCrmTask | undefined;
  executiveAction: string | null | undefined;
  riskFlags: string[] | undefined;
}

export function NextActionsCard({ crmTask, executiveAction, riskFlags }: Props): JSX.Element | null {
  const hasContent = crmTask || executiveAction || (riskFlags && riskFlags.length > 0);
  if (!hasContent) return null;

  return (
    <MiniSection title="Action items">
      {crmTask && (
        <div className="rounded border border-ink-200 bg-white px-2 py-1.5 text-[11px] space-y-0.5">
          <div className="flex items-center gap-2">
            <span className="rounded bg-sky-100 px-1.5 py-0.5 text-[10px] font-mono uppercase text-sky-700">
              {crmTask.type}
            </span>
            <span className="font-medium">{crmTask.title}</span>
            {crmTask.priority && <RiskBadge severity={crmTask.priority} />}
          </div>
          {crmTask.dueDate && <div className="text-ink-600">Due: {crmTask.dueDate}</div>}
        </div>
      )}

      {executiveAction && (
        <div className="rounded border border-purple-100 bg-purple-50 px-2 py-1.5 text-[11px] text-purple-900">
          <div className="text-[10px] font-semibold uppercase tracking-wide text-purple-700">
            Executive action needed
          </div>
          <div className="mt-0.5">{executiveAction}</div>
        </div>
      )}

      {riskFlags && riskFlags.length > 0 && (
        <div className="space-y-1">
          <div className="text-[10px] uppercase tracking-wide text-ink-500">Risk flags</div>
          <ul className="space-y-0.5 text-[11px]">
            {riskFlags.slice(0, 6).map((flag, idx) => (
              <li key={idx} className="rounded bg-red-50 px-1.5 py-0.5 text-red-800">{flag}</li>
            ))}
          </ul>
        </div>
      )}
    </MiniSection>
  );
}
